import ReactDOM from 'react-dom/client';
import './index.css';
import Cookies from 'js-cookie'
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './context/AuthContext';
import { LoaderProvider } from './context/LoaderContext';
import { PlayerProfileProvider } from './context/PlayerProfileContext';
import { SocketProvider } from './context/SocketContext';
import { ScoreCardProvider } from './context/ScoreCardContext';
import { XPProvider } from './context/XPContext';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { Capacitor } from '@capacitor/core';
import { restoreAuthFromPreferences } from './utils/authStorage';

const root = ReactDOM.createRoot(document.getElementById('root'));
const googleClientId = process.env.REACT_APP_GOOGLE_AUTH_TOKEN;

// Check if Google OAuth client ID is configured
if (!googleClientId) {
  console.warn('⚠️ [GOOGLE OAUTH] REACT_APP_GOOGLE_AUTH_TOKEN is not set in environment variables.');
  console.warn('   Google Sign-In will not work until you configure the OAuth client ID.');
  console.warn('   Please add REACT_APP_GOOGLE_AUTH_TOKEN to your .env file.');
} else {
  console.log('✅ [GOOGLE OAUTH] Client ID configured:', googleClientId.substring(0, 20) + '...');
}

// Skip the service worker inside the native Capacitor shell — it caches the
// bundled assets aggressively and causes stale-build bugs in the app. The SW
// is only useful for the web PWA.
if (!Capacitor.isNativePlatform() && 'serviceWorker' in navigator) {
  navigator.serviceWorker
    .register('/sw.js')
    .then((registration) => {
      console.log('Service Worker registered');
    })
    .catch((err) => {
      console.log('Service Worker registration failed:', err);
    });
}

function renderApp() {
  const user_id = Cookies.get('user_id');
  root.render(
    // <React.StrictMode>
    <HelmetProvider>
      <AuthProvider>
        <LoaderProvider>
          <PlayerProfileProvider>
            <SocketProvider userId={user_id}>
              <ScoreCardProvider>
                <XPProvider>
                  <BrowserRouter>
                    {googleClientId ? (
                      <GoogleOAuthProvider clientId={googleClientId}>
                        <App userId={user_id} />
                      </GoogleOAuthProvider>
                    ) : (
                      <App userId={user_id} />
                    )}
                  </BrowserRouter>
                </XPProvider>
              </ScoreCardProvider>
            </SocketProvider>
          </PlayerProfileProvider>
        </LoaderProvider>
      </AuthProvider>
    </HelmetProvider>
    // </React.StrictMode>
  );
}

// On native, restore the auth cookies from native storage BEFORE rendering so the
// app boots already logged in. On web this resolves immediately (no-op).
restoreAuthFromPreferences().finally(renderApp);

reportWebVitals();
